import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const GetScoreByQuestions = 'GET_SCORE_BY_QUESTIONS';

export const useGetScoreByQuestions = (
  fromDate: string,
  toDate: string,
  teamId: number,
  filterIsValid: boolean,
) => {
  const { fetchQuestionsWithScore } = useServicesContext();

  return useQuery({
    queryKey: [GetScoreByQuestions, fromDate, toDate, teamId],
    queryFn: () => fetchQuestionsWithScore(fromDate, toDate, teamId),
    refetchInterval: 60000,
    enabled: filterIsValid && Boolean(teamId),
  });
};
